<tt-page *ngIf="!!page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="info"></ng-container>
        <ng-container *ngTemplateOutlet="list"></ng-container>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="selectproduct_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <ng-container *ngTemplateOutlet="info"></ng-container>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <ng-container *ngTemplateOutlet="list"></ng-container>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>

    <p *ngIf="error" role="alert">{{ error }}</p>
</tt-page>

<p *ngIf="!page && error" role="alert">{{ error }}</p>

<ng-template #info>
    <ng-container *ngIf="!!page">
        <tt-card>
            <tt-tabs [ttSelectedId]="mode" (ttSelectedIdChange)="changeMode($event)">
                <ng-container *ngIf="params.webpage_name === 'materialregister'; else searchFirst">
                    <tt-tab ttId="SELECT" ttLabel="select"></tt-tab>
                    <tt-tab ttId="SEARCH" ttLabel="search"></tt-tab>
                </ng-container>

                <ng-template #searchFirst>
                    <tt-tab ttId="SEARCH" ttLabel="search"></tt-tab>
                    <tt-tab ttId="SELECT" ttLabel="select"></tt-tab>
                </ng-template>
            </tt-tabs>

            <ng-container *ngIf="mode === 'SELECT'">
                <tt-tabs [ttSelectedId]="project" (ttSelectedIdChange)="changeProject($event)">
                    <tt-tab ttId="PJ" ttLabel="project"></tt-tab>
                    <tt-tab ttId="JOB" ttLabel="custact"></tt-tab>
                </tt-tabs>

                <tt-input ttLabel="filterval" [(ttModel)]="page.filterval" ttShowClearButton></tt-input>
            </ng-container>

            <ng-container *ngIf="mode === 'SEARCH'">
                <tt-select *ngIf="page.show_prodgrp_id === '1'" ttRememberId="w_selectproduct.prodgrp_id" ttLabel="prodgrp" [ttModel]="page.prodgrp_id" (ttModelChange)="changeGroup($event)" [ttData]="groups" ttDataId="item_id" ttDataName="item_name" [ttShowClearButton]="page.prodgrp_id !== 'ALL'" ttClearValue="ALL"></tt-select>

                <form (ngSubmit)="search()">
                    <tt-input ttLabel="searchtext" [ttModel]="page.searchtext" (ttModelChange)="changeSearch($event)">
                        <ng-container buttons>
                            <!-- Erase also remembers and resets results when text is already empty. -->
                            <tt-form-field-button ttId="erase" ttIcon="fas fa-eraser" ttType="danger" (ttClick)="clearSearch()"></tt-form-field-button>
                            <tt-form-field-button ttId="search" [ttIcon]="loading ? 'fas fa-spinner fa-spin' : 'fas fa-search'" [ttDisabled]="loading" (ttClick)="search()"></tt-form-field-button>
                        </ng-container>
                    </tt-input>
                </form>
            </ng-container>
        </tt-card>
    </ng-container>
</ng-template>

<ng-template #list>
    <ng-container *ngIf="!!page">
        <tt-list [ttData]="visibleProducts" ttBackStyle [ttGoto]="false" [ttClickable]="canSelect" (ttClick)="select($event.item)"></tt-list>

        <tt-card *ngIf="page.show_setting === '1'">
            <tt-button-settings ttWebpageName="selectproduct"></tt-button-settings>
        </tt-card>
    </ng-container>
</ng-template>
